import PaymentsSummary from './PaymentsSummary';

export default PaymentsSummary;
